import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { toggleNotes } from '../../redux/notes/actions'
import { notesPanelState } from '../../redux/notes/selectors'
import { deletePhoto, updatePhoto } from '../../redux/photo/actions'
import { logout, updateAimProfile } from '../../redux/profile/actions'
import {
  role,
  user,
  isSidebarOpen,
  isAdminLoggedAsClient,
  clientInfo,
  ownAimStatus,
} from '../../redux/profile/selectors'
import {
  pageLogo,
  pageLogoSubject,
  pageParent,
  pageSubtitle,
  title,
  titleCasing,
} from '../../redux/ui/selectors'
import { trackVisualizations } from '../../redux/visualizationsTracking/actions'
import Header, { IProps } from './Header'

const selector = createStructuredSelector({
  role,
  user,
  isSidebarOpen,
  title,
  titleCasing,
  pageLogo,
  pageLogoSubject,
  pageParent,
  pageSubtitle,
  isAdminLoggedAsClient,
  clientInfo,
  notesPanelState,
  ownAimStatus,
})
const actions = {
  toggleNotes,
  trackVisualizations,
  updatePhoto,
  deletePhoto,
  onLogout: logout,
  updateAimProfile,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, Header)
